import { render, staticRenderFns } from "./PointTask.vue?vue&type=template&id=45d45e58&scoped=true"
import script from "./PointTask.vue?vue&type=script&lang=js"
export * from "./PointTask.vue?vue&type=script&lang=js"
import style0 from "./PointTask.vue?vue&type=style&index=0&id=45d45e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d45e58",
  null
  
)

export default component.exports